import React from "react";
import PageTitleProvider from "./PageTitleProvider";

interface TitleProps {
  detail?: string;
  brandName?: string;
}

export default function BrandedPageTitleProvider({
  detail,
  brandName,
}: TitleProps) {
  let titleToShow = "";

  if (detail && brandName) {
    titleToShow = `${brandName}: ${detail}`;
  } else if (detail) {
    titleToShow = detail;
  } else if (brandName) {
    titleToShow = brandName;
  }

  if (!titleToShow) {
    return null;
  }

  return <PageTitleProvider title={titleToShow} />;
}
